export default {
  "Choose File": "Choose File",
  "Please paste a URL": "Please paste a URL",
  Loading: "Loading",
  Analyzing: "Analyzing",
  "Try a sample": "Try a sample",
  "Sorry, error occurs when analyzing the URL.": "Sorry, an error occurs when analyzing the URL.",
  "Upload a photo": "Upload a photo",
  "Drag and drop files to the upload box.": "Drag and drop files to the upload box.",
  "Please select the proper position with portrait.": "Please select the proper position with portrait.",
  downloading: "downloading",
};
